import { Select } from "./ui";
import { useI18n } from "../i18n";
import type { Jurisdiction } from "../api";
import "./JurisdictionField.css";

/**
 * Jurisdiction picker: the shared UI-kit Select plus the caption that explains
 * what the jurisdiction drives. Names come from the API in English and are
 * rendered as-is in both languages. Pass `placeholder` for the "nothing chosen
 * yet" state (project creation); omit it where a value is always present (the
 * per-project dialog seeds the current jurisdiction, retired or not).
 */
export function JurisdictionField({
  options,
  value,
  onChange,
  placeholder,
}: {
  options: Jurisdiction[];
  value: string;
  onChange: (code: string) => void;
  placeholder?: string;
}) {
  const { t } = useI18n();
  return (
    <div className="jurisdiction-field">
      <Select
        value={value}
        placeholder={placeholder}
        aria-label={placeholder ?? t("jurisdiction.dialogTitle")}
        onChange={(e) => onChange(e.target.value)}
      >
        {options.map((o) => (
          <option key={o.code} value={o.code}>
            {o.name}
          </option>
        ))}
      </Select>
      <p className="jurisdiction-field__caption">{t("jurisdiction.caption")}</p>
    </div>
  );
}
